import React, { useEffect, useRef } from "react";
import ReactModal from "react-modal";

const AddLinkModal = ({ isOpen, text, url, onTextChange, onUrlChange, onSave, onClose }) => {
  const textInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => textInputRef.current?.focus(), 50);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Ignore a bare scheme like "https://" so an empty link can't be saved.
  const hasUrl = url.replace(/^https?:\/\//i, "").trim().length > 0;

  // Collapse a doubled scheme, e.g. pasting a full URL after the prefilled
  // "https://" -> "https://https://site.com" becomes "https://site.com".
  const normalizeLinkValue = (value) =>
    value.replace(/^\s*https?:\/\/\s*(https?:\/\/)/i, "$1");

  // On focus (e.g. tabbing in) place the caret at the end so typing continues
  // after the prefilled scheme instead of replacing the whole value.
  const handleLinkFocus = (e) => {
    const len = e.target.value.length;
    e.target.setSelectionRange(len, len);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // The modal renders through a portal, so React still bubbles this submit up
    // to the composer's surrounding <form> and would fire "send message".
    e.stopPropagation();
    if (hasUrl) onSave();
  };

  const canSave = hasUrl;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      className="message-add-link-modal"
      overlayClassName="message-add-link-modal-overlay"
      ariaHideApp={false}
    >
      <div className="message-add-link-modal-header">
        <h2 className="message-add-link-modal-title">Add link</h2>
        <button
          type="button"
          className="message-add-link-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <form className="message-add-link-modal-body" onSubmit={handleSubmit}>
        <label className="message-add-link-field">
          <span className="message-add-link-label">Text</span>
          <input
            ref={textInputRef}
            type="text"
            className="message-add-link-input"
            value={text}
            onChange={(e) => onTextChange(e.target.value)}
            placeholder="Display text"
          />
        </label>

        <label className="message-add-link-field">
          <span className="message-add-link-label">Link</span>
          <input
            type="text"
            inputMode="url"
            className="message-add-link-input"
            value={url}
            onChange={(e) => onUrlChange(normalizeLinkValue(e.target.value))}
            onFocus={handleLinkFocus}
            placeholder="https://"
          />
        </label>

        <div className="message-add-link-modal-footer">
          <button type="button" className="message-add-link-btn message-add-link-btn--cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            type="submit"
            className="message-add-link-btn message-add-link-btn--save"
            disabled={!canSave}
          >
            Save
          </button>
        </div>
      </form>
    </ReactModal>
  );
};

export default AddLinkModal;
